export class UnifiedDBServerRecord {
    'serverId';
    'serverName';
    'serverType';
    'engineType';
    'engineVersion';
    'dbCount';
    'databases';
    'recordType';
    'snapshot';
    'resource';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "serverId",
            "baseName": "serverId",
            "type": "string",
            "format": ""
        },
        {
            "name": "serverName",
            "baseName": "serverName",
            "type": "string",
            "format": ""
        },
        {
            "name": "serverType",
            "baseName": "serverType",
            "type": "string",
            "format": ""
        },
        {
            "name": "engineType",
            "baseName": "engineType",
            "type": "string",
            "format": ""
        },
        {
            "name": "engineVersion",
            "baseName": "engineVersion",
            "type": "string",
            "format": ""
        },
        {
            "name": "dbCount",
            "baseName": "dbCount",
            "type": "number",
            "format": ""
        },
        {
            "name": "databases",
            "baseName": "databases",
            "type": "Array<UnifiedDatabaseRecord>",
            "format": ""
        },
        {
            "name": "recordType",
            "baseName": "record_type",
            "type": "string",
            "format": ""
        },
        {
            "name": "snapshot",
            "baseName": "snapshot",
            "type": "DBSnapshotMetadata",
            "format": ""
        },
        {
            "name": "resource",
            "baseName": "resource",
            "type": "DBResourceMetadata",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return UnifiedDBServerRecord.attributeTypeMap;
    }
    constructor() {
    }
}
